// src/components/AnalyticsStatTiles.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers, faUserPlus, faIdCard, faCakeCandles, faFolderOpen
} from '@fortawesome/free-solid-svg-icons';

function DeltaChip({ metric, days }) {
  const { current, previous } = metric;
  if (previous === 0 && current === 0) {
    return <span className="analytics-delta analytics-delta-neutral">— no change</span>;
  }
  if (previous === 0) {
    return <span className="analytics-delta analytics-delta-positive">▲ up from 0 vs prior {days}d</span>;
  }
  const pct = Math.round(((current - previous) / previous) * 100);
  if (pct === 0) {
    return <span className="analytics-delta analytics-delta-neutral">— flat vs prior {days}d</span>;
  }
  const positive = pct > 0;
  return (
    <span className={`analytics-delta ${positive ? 'analytics-delta-positive' : 'analytics-delta-negative'}`}>
      {positive ? '▲' : '▼'} {Math.abs(pct)}% vs prior {days}d
    </span>
  );
}

function AnalyticsStatTiles({ platform, days }) {
  if (!platform) return null;

  const tiles = [
    {
      key: 'active',
      icon: faUsers,
      label: `Active users (${days}d)`,
      value: platform.activeUsers[`last${days}d`] ?? platform.activeUsers.last7d,
      // Active-user counts derive from each user's single last-active timestamp,
      // so a vs-prior-window delta would be misleading — show the base instead.
      footer: <span className="analytics-delta analytics-delta-neutral">of {platform.totals.users} total</span>,
    },
    {
      key: 'newUsers',
      icon: faUserPlus,
      label: 'New app users',
      value: platform.newUsers.current,
      footer: <DeltaChip metric={platform.newUsers} days={days} />,
    },
    {
      key: 'newMembers',
      icon: faIdCard,
      label: 'New members',
      value: platform.newMembers.current,
      footer: <DeltaChip metric={platform.newMembers} days={days} />,
    },
    {
      key: 'wishes',
      icon: faCakeCandles,
      label: 'Birthday wishes',
      value: platform.birthdayWishes.current,
      footer: <DeltaChip metric={platform.birthdayWishes} days={days} />,
    },
    {
      key: 'directory',
      icon: faFolderOpen,
      label: 'Directory changes',
      value: platform.directoryChanges.current,
      footer: <DeltaChip metric={platform.directoryChanges} days={days} />,
    },
  ];

  return (
    <div className="analytics-tiles">
      {tiles.map((tile) => (
        <div key={tile.key} className="analytics-tile">
          <div className="analytics-tile-label">
            <FontAwesomeIcon icon={tile.icon} className="analytics-tile-icon" />
            {tile.label}
          </div>
          <div className="analytics-tile-value">{tile.value.toLocaleString()}</div>
          <div className="analytics-tile-footer">{tile.footer}</div>
        </div>
      ))}
    </div>
  );
}

export default AnalyticsStatTiles;
